var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ProtectedActionError = /** @class */ (function (_super) {
    __extends(ProtectedActionError, _super);
    function ProtectedActionError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "PROTECTED_ACTION";
        return _this;
    }
    return ProtectedActionError;
}(Error));
export { ProtectedActionError };
export var isProtectedActionError = function (error) { return error !== null && typeof error === "object" && "type" in error && error.type === "PROTECTED_ACTION"; };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJvdGVjdGVkQWN0aW9uRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJQcm90ZWN0ZWRBY3Rpb25FcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTtJQUEwQyx3Q0FBSztJQUEvQztRQUFBLHFFQUVDO1FBREMsVUFBSSxHQUFHLGtCQUFrQixDQUFDOztJQUM1QixDQUFDO0lBQUQsMkJBQUM7QUFBRCxDQUFDLEFBRkQsQ0FBMEMsS0FBSyxHQUU5Qzs7QUFFRCxNQUFNLENBQUMsSUFBTSxzQkFBc0IsR0FBRyxVQUNwQyxLQUFtQixJQUNlLE9BQUEsS0FBSyxLQUFLLElBQUksSUFBSSxPQUFPLEtBQUssS0FBSyxRQUFRLElBQUksTUFBTSxJQUFJLEtBQUssSUFBSSxLQUFLLENBQUMsSUFBSSxLQUFLLGtCQUFrQixFQUFuRyxDQUFtRyxDQUFDIn0=